import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import { useContext, useEffect, useState, useRef } from "react";
import {
  addCoursePost,
  addFeedPost,
  addForumPost,
  getAdminDetails,
  getTags,
  regionCountryList,
} from "../../Utils/services";
import { toast } from "react-toastify";
import { ModalContext } from "../../Context";
import Loader from "../Common/Loader";
import {
  Checkbox,
  FormControlLabel,
  Radio,
  RadioGroup,
} from "@material-ui/core";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { CountryOPtion, CourseOption, CourseType } from "../Common/Option";
import { useTranslation } from "react-i18next";
import "react-image-crop/dist/ReactCrop.css";
//import Cropper, { ReactCropperElement } from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Cropper } from "react-cropper";

const AddCourse = ({ getFeedData, title, data }) => {
  const { t } = useTranslation();
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState([]);
  const [formData, setFormData] = useState({});
  const [imgFile, setImgFile] = useState("");
  const [imgFile2, setImgFile2] = useState("");
  const [imgFile3, setImgFile3] = useState("");
  const [loader, setLoader] = useState(false);
  const [src, setSrc] = useState(null);
  const [mediaType, setMediaType] = useState("photo");
  const [tags, setTags] = useState([]);
  const [tagsValue, setTagsValue] = useState([]);
  const [CourseType, setCourseType] = useState("Beginner");
  // const [adminType, setAdminType] = useState();
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [article, setArticle] = useState("");
  const [showImgError, setshowImgError] = useState(false);
  const [result, setResult] = useState(null);
  const [sendImageFile, setSendImageFile] = useState("");
  const [imgFilecrop, setImgFilecrop] = useState("");
  const [disableButton, setDisableButton] = useState(false);
  const onEditorStateChange = (editorState) => {
    setEditorState(editorState);
    let convertedData = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    setArticle(convertedData);
  };

  const embedVideoCallBack = (link) => {
    link = link.replace("watch?v=", "embed/");
    link = link.replace("/watch/", "/embed/");
    link = link.replace("youtu.be/", "youtube.com/embed/");
    return link;
  };

  // const getCountryData = async () => {
  //     try {
  //         const result = await regionCountryList();
  //         setCountries(result?.res?.data?.country)
  //     }
  //     catch (error) {
  //         console.log(error);
  //         toast.warning("Something went wrong!")
  //     }
  // }
  const adminId = localStorage.getItem("adminId");

  const getAdminDetailsApiData = async () => {
    try {
      const result = await getAdminDetails({
        id: adminId,
        type: "admin",
      });
      setCountries(result.data.country);
    } catch (error) {
      console.log(error);
    }
  };
  const geTagsApi = async () => {
    try {
      const result = await getTags();
      if (result.res.success) {
        setTags(result.res.data);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  useEffect(() => {
    getAdminDetailsApiData();
    // getCountryData();
    geTagsApi();
  }, []);

  const onInputCountryChange = (event, newInputValue, name) => {
    setCountry({
      ...country,
      [name]: newInputValue,
    });
  };

  const onInputTagsChange = (event, newInputValue, name) => {
    setTagsValue({
      ...tagsValue,
      [name]: newInputValue,
    });
  };

  // const onInputSectorsChange = (event, newInputValue, name) => {
  //     setCourseType({
  //       ...CourseType,
  //       [name]: newInputValue,
  //     });
  //   };

  const handleImgFile = (val) => {
    if (!!val) {
      let img = new Image();
      img.src = window.URL.createObjectURL(val);
      const fileSizeInBytes = val.size;
      const fileSizeInKilobytes = fileSizeInBytes / 1024; // Convert bytes to kilobytes
      console.log(`File size: ${fileSizeInKilobytes} KB`);
      img.onload = () => {
        if (img.width === 400 && img.height === 400) {
          setImgFile(val);
          setMediaType("photo");
          setshowImgError(false);
          setImgFilecrop("");
          setSrc(null);
        } else {
          setImgFile("");
          setshowImgError(true);
          setMediaType("photo");
          setImgFilecrop(val);
          setSrc(URL.createObjectURL(val));
        }
      };
    }
    if (val.name !== "") {
        setDisableButton(true);
      }
  };
  const handleImgFile2 = (val) => {
    if (!!val) {
      let img = new Image();
      img.src = window.URL.createObjectURL(val);

      img.onload = () => {
        if (img.width === 400 && img.height === 400) {
          setImgFile2(val);
          setMediaType("photo");
          setshowImgError(false);
        } else {
          setImgFile2("");
          setshowImgError(true);
        }
      };
    }
  };
  const handleImgFile3 = (val) => {
    if (!!val) {
      let img = new Image();
      img.src = window.URL.createObjectURL(val);

      img.onload = () => {
        if (img.width === 400 && img.height === 400) {
          setImgFile3(val);
          setMediaType("photo");
          setshowImgError(false);
        } else {
          setImgFile3("");
          setshowImgError(true);
        }
      };
    }
  };

  const context = useContext(ModalContext);
  const { closeModal } = context;

  const onChangeHandler = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    setFormData({ ...formData, [name]: value });
  };

  const handlePostSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    const tagsData = tagsValue?.tags?.map((data) => {
      return data._id;
    });
    const countryData = country?.country?.map((data) => {
      return data._id;
    });
    const postFormData = new FormData();
    postFormData.append("title", formData.question ? formData.question : "");
    postFormData.append("CourseType", CourseType ? CourseType : "");
    postFormData.append(
      "CourseDuretion",
      formData.CourseDuration ? formData.CourseDuration : ""
    );
    postFormData.append("tags", tagsData);
    postFormData.append("country", countryData);
    postFormData.append("description", article ? article : "");
    postFormData.append(
      "media",
      sendImageFile && sendImageFile ? sendImageFile : imgFile
    );
    postFormData.append("mediaType", mediaType);

    try {
      const result = await addCoursePost(postFormData);
      if (result.res.success) {
        toast.success(result.res.message);
        closeModal();
        getFeedData({
          page: 0,
          postsPerPage: 10,
        });
        setLoader(false);
        console.log(result.res, "This is result response");
      }
    } catch (error) {
      setLoader(false);
      console.log(error);
      toast.error(error.message);
    }
  };

  function dynamicSort(property) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a, b) {
      var result =
        a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  const onAdminChangeHandler = (e) => {
    e.preventDefault();
    // setCountry([]);
    const value = e.target.value;
    setCourseType(value);
  };

  const cropperRef = useRef(null);
  const getCropData = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      const croppedCanvas = cropperRef.current?.cropper.getCroppedCanvas();

      // Resize the canvas to reduce file size
      const resizedCanvas = document.createElement("canvas");
      const maxWidth = 800; // Adjust the maximum width as needed
      const maxHeight = 800; // Adjust the maximum height as needed
      const scale = Math.min(
        maxWidth / croppedCanvas.width,
        maxHeight / croppedCanvas.height
      );

      resizedCanvas.width = croppedCanvas.width * scale;
      resizedCanvas.height = croppedCanvas.height * scale;

      const ctx = resizedCanvas.getContext("2d");
      ctx.drawImage(
        croppedCanvas,
        0,
        0,
        resizedCanvas.width,
        resizedCanvas.height
      );

      // Convert the resized canvas to a data URL
      const resizedDataURL = resizedCanvas.toDataURL("image/jpeg", 0.8); // Adjust quality as needed
      setResult(resizedDataURL);
      // Create a Blob from the data URL and set the compressed file
      fetch(resizedDataURL)
        .then((res) => res.blob())
        .then((blob) => {
          const compressedFile = new File([blob], "compressed_image1.jpg", {
            type: "image/jpeg",
          });

          // Set the compressed file for further use (e.g., sending to the server)
          setSendImageFile(compressedFile);
          //  setImgFile(compressedFile);

          // Optional: Set the compressed image data URL
          console.log(resizedDataURL, "resizedDataURL");
        })
        .catch((error) => {
          console.error("Error resizing image:", error);
        });
    }
  };
  const getCropremove = () => {
    setImgFile("");
    setResult("");
    setMediaType("");
    setshowImgError(false);
    setImgFilecrop("");
    setSrc(null);

    const fileInput = document.querySelector('input[name="image-file"]');
    if (fileInput) {
      fileInput.value = ""; // Clear the value to allow re-selection of the same file
    }
  };
//   console.log(imgFile.name, "imgFile.name ");
//   console.log(result, "result");
  return (
    <>
      <Loader loader={loader} />
      <div className="flex items-center justify-center">
        <h3 className="title">{t("add_Course")}</h3>
      </div>
      <div noValidate autoComplete="off" className="w-full">
        <RadioGroup
          aria-label="CourseType"
          name="CourseType"
          className="radio-group"
          defaultValue={CourseType}
          onChange={(e) => onAdminChangeHandler(e)}
        >
          <FormControlLabel
            value="Beginner"
            control={<Radio />}
            label={t("Beginner")}
          />
          <FormControlLabel
            value="Intermediate"
            control={<Radio />}
            label={t("Intermediate")}
          />
          <FormControlLabel
            value="Advanced"
            control={<Radio />}
            label={t("Advanced")}
          />
          {/* <FormControlLabel value="Coordination team" control={<Radio />} label="Coordination team" /> */}
        </RadioGroup>
        <div className="mt-4 w-6/12"></div>
        <div className="grid grid-cols-2 gap-x-24 gap-y-4">
          <div className="col-span-2">
            <TextareaAutosize
              name="question"
              value={formData.question || ""}
              onChange={(e) => onChangeHandler(e)}
              className="w-full"
              id="postname"
              aria-label="Empty"
              placeholder={t("Title")}
              minRows={3}
            />
          </div>
          <div className="editorSectionStart col-span-2">
            <Editor
              editorState={editorState}
              toolbarClassName="toolbarClassName"
              wrapperClassName="wrapperClassName"
              editorClassName="editorClassName"
              onEditorStateChange={onEditorStateChange}
              toolbar={{
                embedded: {
                  embedCallback: embedVideoCallBack,
                },
              }}
            />
          </div>
          {/* <Autocomplete
                       id="sectors"
                       options={CourseOption?.sort(dynamicSort("name"))}
                       getOptionLabel={(option) => option?.value || ""}
                       sx={{ width: 300 }}
                       value={CourseType?.value}
                       onChange={(e, newVal) => onInputSectorsChange(e, newVal, "CourseType")}
                       renderInput={(params) => <TextField {...params} label="CourseType" />}
                     /> */}
          <TextField
            id="CourseDuration"
            label={t("Course_Duration")}
            name="CourseDuration"
            value={formData.CourseDuration || ""}
            onChange={(e) => onChangeHandler(e)}
          />
          <Autocomplete
            id="combo-box-demo22"
            multiple
            options={countries?.sort(dynamicSort("name"))}
            getOptionLabel={(option) => option?.name}
            sx={{ width: 300 }}
            value={country?.name}
            onChange={(e, newVal) => onInputCountryChange(e, newVal, "country")}
            renderInput={(params) => (
              <TextField {...params} label={t("Country")} />
            )}
          />
          <Autocomplete
            id="combo-box-demo2"
            multiple
            options={tags?.sort(dynamicSort("name"))}
            getOptionLabel={(option) => option?.name}
            sx={{ width: 300 }}
            value={tagsValue?.name}
            onChange={(e, newVal) => onInputTagsChange(e, newVal, "tags")}
            renderInput={(params) => (
              <TextField {...params} label={t("Tags")} />
            )}
          />
        </div>
        <div className="mt-12 w-12/12">
          <Grid container alignItems="center" spacing={4}>
            <Grid item md={1}>
              <span className="text-paraText">{t("Add_Media")}</span>
            </Grid>
            <Grid item md={3}>
              <div className="relative w-auto overflow-hidden">
                <TextField
                  id="profilephoto"
                  label={t("Add_Photo")}
                  value={(imgFile.name || result || "").slice(0, 25)}
                  className="w-full text-xs"
                />
                <input
                  type="file"
                  accept="image/*"
                  className="z-50 opacity-0 absolute bottom-0 right-0 w-50"
                  name="image-file"
                  onChange={(e) => handleImgFile(e.target.files[0])}
                />
                <div className="floating-box">+</div>
              </div>
              <div className="media-box mt-2">
                <img src="../../assets/photos.svg" alt="" />
                {t("Photo")}
              </div>
            </Grid>
            {/* <Grid item md={3}>
                            <div className="relative w-auto overflow-hidden">
                                <TextField
                                    id="profilephoto"
                                    label="Add Photo 2"
                                    value={imgFile2.name || ""}
                                    className="w-full text-xs"
                                />
                                <input
                                    type="file"
                                    accept="image/*"
                                    className="z-50 opacity-0 absolute bottom-0 right-0 w-50"
                                    name="image-file"
                                    onChange={(e) => handleImgFile2(e.target.files[0])}
                                />
                                <div className="floating-box" >+</div>
                            </div>
                            <div className="media-box mt-2" >
                                <img src="../../assets/photos.svg" alt="" />
                                Photo
                            </div>
                        </Grid> */}
            {/* <Grid item md={3}>
                            <div className="relative w-auto overflow-hidden">
                                <TextField
                                    id="profilephoto"
                                    label="Add Photo 3"
                                    value={imgFile3.name || ""}
                                    className="w-full text-xs"
                                />
                                <input
                                    type="file"
                                    accept="image/*"
                                    className="z-50 opacity-0 absolute bottom-0 right-0 w-50"
                                    name="image-file"
                                    onChange={(e) => handleImgFile3(e.target.files[0])}
                                />
                                <div className="floating-box" >+</div>
                            </div>
                            <div className="media-box mt-2" >
                                <img src="../../assets/photos.svg" alt="" />
                                Photo
                            </div>
                        </Grid> */}
            {src ? (
              ""
            ) : (
              <p className="mt-4 text-sidenav">
                {" "}
                {t("Image_shouldbe400x400px")}
              </p>
            )}
          </Grid>
          {src && (
            <div className="col-3 cropperclass">
              {/* <ReactCrop
                          src={src}
                          onImageLoaded={setImage}
                          crop={crop}
                          onChange={setCrop}
                        /> */}
              <Cropper
                style={{ height: 400, width: "50%" }}
                initialAspectRatio={2 / 1}
                //preview=".img-preview"
                aspectRatio={2 / 1}
                src={src}
                ref={cropperRef}
                viewMode={10}
                guides={true}
                minCropBoxHeight={10}
                minCropBoxWidth={10}
                background={false}
                responsive={true}
                checkOrientation={false}
              />
              {/* <div className='Zoombtn'>
                        <button  className='zoombutton' onClick={handleZoomIn}>+</button>
                        <button  className='zoombutton' onClick={handleZoomOut}>-</button>
                        </div> */}
              <div className="Zoombtn">
                <button
                  variant="contained"
                  onClick={getCropData}
                  className="cropbutton"
                >
                  Crop Image
                </button>
                <button
                  variant="contained"
                  onClick={getCropremove}
                  className="cropbutton"
                >
                  Remove Crop
                </button>
              </div>
            </div>
          )}
        </div>
        <div className="flex justify-center mt-10">
          <button
            className={`mx-auto ${
              result != null ||
              (imgFile.name != undefined &&
                formData.question != undefined &&
                formData.question != "" &&
                country?.country?.length > 0 &&
                tagsValue?.tags?.length > 0 &&
                article.length > 8)
                ? "button-1"
                : "buttons-1"
            }`}
            disabled={
              result != null ||
              (imgFile.name != undefined &&
                formData.question != undefined &&
                formData.question != "" &&
                country?.country?.length > 0 &&
                tagsValue?.tags?.length > 0 &&
                article.length > 8)
                ? false
                : true
            }
            onClick={handlePostSubmit}
          >
            {t("Submit")}
          </button>
        </div>
      </div>
    </>
  );
};

export default AddCourse;
